<template>
  <div>
    <!-- <el-collapse v-model="activeNames">
      <el-collapse-item name="0" title="基本信息">
        <subscriber-info :subscriber-id="subscriberId"></subscriber-info>
      </el-collapse-item>
      <el-collapse-item name="1" title="小程序信息">
        <subscriber-ma :subscriber-id="subscriberId"></subscriber-ma>
      </el-collapse-item>
      <el-collapse-item name="2" title="收货地址">
        <subscriber-contact :subscriber-id="subscriberId"></subscriber-contact>
      </el-collapse-item>
    </el-collapse> -->
    <subscriber-info :subscriber-id="subscriberId"></subscriber-info>
    <el-tabs value="1" stretch>
      <el-tab-pane label="小程序信息" name="1">
        <subscriber-ma :subscriber-id="subscriberId"></subscriber-ma>
      </el-tab-pane>
      <el-tab-pane label="收货地址" name="2">
        <subscriber-contact :subscriber-id="subscriberId"></subscriber-contact>
      </el-tab-pane>
      <el-tab-pane label="优惠券" name="3">
        <subscriber-coupon :subscriber-id="subscriberId"></subscriber-coupon>
      </el-tab-pane>
      <el-tab-pane label="订单" name="4">
        <subscriber-order :subscriber-id="subscriberId"></subscriber-order>
      </el-tab-pane>
      <el-tab-pane label="活动记录" name="5"> </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import { getSubscriberInfoApi } from "@/api/subscriber";
import SubscriberMa from "./subscriberMa";
import SubscriberContact from "./subscriberContact";
import SubscriberInfo from "./subscriberInfo";
import SubscriberCoupon from "./subscriberCoupon";
import SubscriberOrder from "./subscriberOrder";
export default {
  name: "detail",
  components: {
    SubscriberMa,
    SubscriberContact,
    SubscriberInfo,
    SubscriberCoupon,
    SubscriberOrder
  },
  data() {
    return {
      subscriberId: undefined,
      activeNames: ["0", "1", "2"]
    };
  },
  watch: {
    "$route.query.id": {
      handler(val) {
        this.subscriberId = val;
      },
      immediate: true
    }
  },
  created() {},
  mounted() {},
  methods: {}
};
</script>
<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// detail.vue?6e9e1568